import { Env } from '@didi/utils'
import { noop, getContent } from '../util/tool'
import { wechatInnerBridgeReady } from '../core/wechatBridge'
import { mqqReady } from '../core/mqq'
import { alipayReady } from '../core/alipay'
import commonLangZh from '../lang/zh-CN/common'
import commonLangEn from '../lang/en-US/common'
import payLangZh from '../lang/zh-CN/pay'
import payLangEn from '../lang/en-US/pay'

const PAY_SUCCESS_MSG = 'pay success'

const WAY_WECHAT = 'wechat'
const WAY_ALIPAY = 'alipay'
const WAY_MQQ = 'mqq'
const WAY_H5 = 'h5'
const allContent = {
  'zh-CN': {
    ...commonLangZh,
    ...payLangZh
  },
  'en-US': {
    ...commonLangEn,
    ...payLangEn
  }
}
let lang
/**
 * 拉起支付
 * @param conf
 * conf.lang 多语言支持，目前支持zh-CN|en-US; 默认为zh-CN
 * conf 其他参数同拉起支付时需要参数
 *    微信中：
 *      "timeStamp": "1510307967",
        "package": "prepay_id=wx2017111018000739e61a58e20027089901",
        "paySign": "7DB07E98CAB05BBB94761211D14D2729",
        "appId": "wx4d1a99cc3d09584b",
        "signType": "MD5",
        "nonceStr": "joy6ei57z2xmxn6p153mptkxlw36jpys"
      支付宝：
        "zfb_params": {
        "tradeNO": "7DB07E98CAB05BBB94761211D14D2729"
      手机QQ
        prepayId: "xxxx",
        pubAcc: "xxxx",
        pubAccHint: "xxxx"
 */
export function pay (conf, callback = noop) {
   /* istanbul ignore else */
  if (conf && conf.lang) {
    lang = conf.lang
  }
  if (Env.isWechat) {
    wechatPay(conf, callback)
  } else if (Env.isAlipay) {
    alipayPay(conf, callback)
  } else if (Env.isMqq) {
    mqqPay(conf, callback)
  } else {
    h5Pay(conf, callback)
  }
}
export default pay

function wechatPay(conf, callback) {
  wechatInnerBridgeReady((err, WeixinJSBridge) => {
     /* istanbul ignore else */
    if (err) {
      callback(err)
      return
    }
     /* istanbul ignore else */
    if (!WeixinJSBridge) {
      callback(new Error(getContent(allContent, 'wechatBridgeError', lang)))
      return
    }
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      conf,
      (res) => {
        let errMsg = ''
        let msg = res.err_msg || res.errMsg
        switch (msg) {
          case 'get_brand_wcpay_request:ok':
          case 'chooseWXPay:ok':
            errMsg = ''
            break
          case 'get_brand_wcpay_request:cancel':
          case 'chooseWXPay:cancel':
            errMsg = getContent(allContent, 'payCancel', lang)
            break
          case 'get_brand_wcpay_request:fail':
          case 'chooseWXPay:fail':
            errMsg = getContent(allContent, 'payError', lang)
            break
          default:
            errMsg = getContent(allContent, 'payError', lang) + msg
        }
        if (errMsg) {
          callback && callback(new Error(errMsg))
        } else {
          callback && callback(null, {
            msg: PAY_SUCCESS_MSG,
            from: WAY_WECHAT
          })
        }
      }
    )
  })
}

function alipayPay(conf, callback) {
  alipayReady((err, AlipayJSBridge) => {
     /* istanbul ignore else */
    if (err) {
      callback(err)
      return
    }
     /* istanbul ignore else */
    if (!AlipayJSBridge) {
      callback(new Error(getContent(allContent, 'alipayBridgeError', lang)))
      return
    }
    AlipayJSBridge.call('tradePay', conf, (data) => {
      let status = data.resultCode
      let errMsg = ''
      switch (status) {
      case '9000':  // 支付成功
      case '8000':  // 正在处理中
        errMsg = ''
        break
      case '6001':  // 中途取消
        errMsg = getContent(allContent, 'payCancel', lang)
        break
      // case "6002":  // 网络出错
      // case "4000":  // 支付失败
      //   errMsg = '支付发生错误，请稍后再试!'
      //   break;
      default:
        errMsg = getContent(allContent, 'payError', lang)
      }
      if (errMsg) {
        callback && callback(new Error(errMsg))
      } else {
        callback && callback(null, {
          status: status,
          msg: PAY_SUCCESS_MSG,
          from: WAY_ALIPAY
        })
      }
    })
  })
}

function mqqPay(conf, callback) {
  mqqReady((err, mqq) => {
     /* istanbul ignore else */
    if (err) {
      callback(err)
      return
    }
    mqq.tenpay.pay(conf, (res) => {
      let status = res.resultCode
      if (+status === 0) {
        callback(null, {
          msg: PAY_SUCCESS_MSG,
          from: WAY_MQQ
        })
      } else {
        callback(new Error(getContent(allContent, 'payError', lang)))
      }
    })
  })
}

function h5Pay(conf, callback) {
  if (conf.pay_string) {
    window.location.href = conf.pay_string
    callback(null, {
      msg: PAY_SUCCESS_MSG,
      from: WAY_H5
    })
  } else {
    callback(new Error(getContent(allContent, 'payError', lang)))
  }
}
